import { useNavigate } from "react-router-dom";import "./RelatedProduct.css";

import img1 from "./Images/image 1 (3).png";
import img2 from "./Images/image 3 (2).png";
import img3 from "./Images/image 1 (4).png";
import img4 from "./Images/image 3 (3).png";

const products = [
  {
    id: 1,
    name: "Gulab Banarasi Saree",
    price: 2500,
    oldPrice: 3500,
    discount: "-30%",
    image: img1,
    rating:3
  },
  {
    id: 2,
    name: "Kesari Paithani",
    price: 7000,
    oldPrice: 14000,
    discount: "-50%",
    image: img2,
     rating:5
  },
  {
    id: 3,
    name: "Syltherine",
    price: 2500,
    oldPrice: 3500,
    discount: "-30%",
    image: img3,
     rating:2
  },
  {
    id: 4,
    name: "Neelkamal Silk Saree",
    price: 7000,
    oldPrice: 14000,
    discount: "-50%",
    image: img4,
     rating:4
  },
];

const RelatedProducts = () => {
  const navigate = useNavigate();
  return (
    <div className="related-container">
      <h2>Related Products</h2>

      <div className="product-grid">
        {products.map((item) => (
          <div className="product-card" key={item.id}>
            <div className="image-wrapper">
              <img src={item.image} alt={item.name} />
              <span className="discount">{item.discount}</span>
            </div>

            <div className="product-info">
              <h3>{item.name}</h3>

<div className="stars">
  {[...Array(5)].map((_, i) => (
    <svg
      key={i}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 1L13 7L19 7.75L14.88 12.37L16 19L10 16L4 19L5.13 12.37L1 7.75L7 7L10 1Z"
        fill={i < item.rating ? "#FFC700" : "#E0E0E0"}
      />
    </svg>
  ))}
</div>
              <div className="pricez">
                <span className="new">Rs {item.price}</span>
                <span className="old">Rs {item.oldPrice}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

<button 
  className="show-btn" 
  onClick={() => navigate("/shop")}
>
  Show More
</button>    </div>
  );
};

export default RelatedProducts;